var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3706 1.58057C12.5165 1.7264 12.5894 1.90348 12.5894 2.11182C12.5894 2.32015 12.5165 2.49723 12.3706 2.64307L6.71438 8.29932L5.65188 9.36182C5.50604 9.50765 5.32896 9.58057 5.12063 9.58057C4.91229 9.58057 4.73521 9.50765 4.58938 9.36182L3.52688 8.29932L0.698753 5.47119C0.55292 5.32536 0.480003 5.14827 0.480003 4.93994C0.480003 4.73161 0.55292 4.55452 0.698753 4.40869L1.76125 3.34619C1.90709 3.20036 2.08417 3.12744 2.2925 3.12744C2.50084 3.12744 2.67792 3.20036 2.82375 3.34619L5.12063 5.65088L10.2456 0.518066C10.3915 0.372233 10.5685 0.299316 10.7769 0.299316C10.9852 0.299316 11.1623 0.372233 11.3081 0.518066L12.3706 1.58057Z",
    fill: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccessIcon);
export default __webpack_public_path__ + "static/media/check-success-icon.3db9092e04e52d3dea3dd703a395dd2e.svg";
export { ForwardRef as ReactComponent };